import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar } from 'lucide-react';
export function CTASlide() {
  return <div className="h-full w-full flex flex-col items-center justify-center px-8 bg-slate-950 relative overflow-hidden" data-id="element-19">
      {/* Background gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-20">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-600/20 rounded-full blur-[100px]" data-id="element-21" />
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8
    }} className="text-center relative z-10 max-w-4xl" data-id="element-22">
        <h2 className="text-6xl md:text-7xl font-bold text-white mb-8 tracking-tight" data-id="element-23">
          Ready to Scale?
        </h2>
        <p className="text-2xl md:text-3xl text-slate-300 mb-12 font-light" data-id="element-24">
          Let's discuss how we can optimize your operations and future-proof
          your business.
        </p>

        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="group relative inline-flex items-center gap-3 px-8 py-4 bg-blue-600 hover:bg-blue-500 text-white text-xl font-bold rounded-full transition-all shadow-lg shadow-blue-900/50" data-id="element-25">
          <Calendar className="w-6 h-6" data-id="element-26" />
          <span data-id="element-27">Schedule a Demo</span>
          <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-28" />
        </motion.button>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5,
      duration: 0.8
    }} className="absolute bottom-12 text-slate-500 text-sm" data-id="element-29">
        © 2024 EV Solutions. All rights reserved.
      </motion.div>
    </div>;
}